import React from "react";
import { LoadingSpinner } from "./LoadingSpinner";


interface LoadingNotificationProps {
  isVisible: boolean;
  message: string;
  seconds?: number;
}

export const LoadingNotification: React.FC<LoadingNotificationProps> = ({
  isVisible,
  message,
  seconds,
}) => {
  if (!isVisible) return null;

  return (
    <div className="flex items-center gap-2 px-4 py-3 rounded-lg shadow-lg bg-[var(--bg-elevated)] border-l-4 border-l-[var(--status-success)] border border-[var(--border-subtle)] text-[13px] font-medium text-[var(--status-success)]">
      <LoadingSpinner className="h-4 w-4" />
      {seconds !== undefined ? `${message}... (${seconds}s)` : message}
    </div>
  );
};
